import { SchemaHelperWebComponent } from './component/SchemaHelperWebComponent';
import { WEB_COMPONENT_SCHEMA_HELPER } from '../../../webcomponents.constants';

export { SchemaHelperWebComponent };

window.customElements.define(WEB_COMPONENT_SCHEMA_HELPER, SchemaHelperWebComponent);
